import { StoryCard } from '../../services';
import { ReactionsCount } from '../../shared';

interface ReactOnCardReducerArgs {
  card: StoryCard;
  reaction: string;
  reactions: ReactionsCount[];
}

export const reactOnCardReducer = ({ card, reaction, reactions }: ReactOnCardReducerArgs) => {
  card.myReaction = card.myReaction === reaction ? '' : reaction;
  card.reactions = reactions;
};
